import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import ReactSelect from 'react-select'
import CreatableSelect from 'react-select/creatable'

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 15px 0;
`

export const SelectComponent = styled(ReactSelect)<{ error?: boolean }>`
  .Select__control {
    border-radius: 8px;

    border: 1px solid
      ${({ theme, error }) =>
        error ? theme.colors.error : theme.colors.border};

    font-size: 16px;
    min-height: 48px;
  }

  .Select__control--is-disabled {
    background: ${({ theme }) => theme.colors.backgroundPrimary};
  }
  .Select__menu {
    z-index: 15;
  }
  .Select__multi-value {
    z-index: 2;
  }
`

export const SelectComponentLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -8px;
  box-sizing: border-box;
  padding: 0px 5px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
  z-index: 11;
`

export const SelectArrowContainer = styled.div``

export const SelectArrow = styled(SVG)`
  width: 15px;
  height: 15px;
  fill: ${({ theme }) => theme.colors.primary};
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
`

export const SelectAutocompleteContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 15px 0;
`

export const SelectAutocompleteLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -8px;
  box-sizing: border-box;
  padding: 0px 5px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
  z-index: 11;
`

export const SelectAutocomplete = styled(ReactSelect)<{ error?: boolean }>`
  .Select__control {
    border-radius: 8px;
    border: 1px solid
      ${({ theme, error }) =>
        error ? theme.colors.error : theme.colors.border};
    font-size: 16px;
    min-height: 48px;
  }

  .Select__control--is-disabled {
    background: ${({ theme }) => theme.colors.backgroundPrimary};
  }
  .Select__menu {
    z-index: 15;
  }
  .Select__multi-value {
    z-index: 14;
    max-width: 95%;
  }
`
export const SelectCreatable = styled(CreatableSelect)<{ error?: boolean }>`
  .Select__control {
    border-radius: 8px;
    border: 1px solid
      ${({ theme, error }) =>
        error ? theme.colors.error : theme.colors.border};
    font-size: 16px;
    min-height: 48px;
  }
  .Select__control--is-disabled {
    background: ${({ theme }) => theme.colors.backgroundPrimary};
  }
  .Select__menu {
    z-index: 15;
  }
  .Select__multi-value {
    z-index: 14;
    max-width: 95%;
  }
`

export const SelectColorIcon = styled.div<{ hex: string }>`
  width: 30px;
  height: 30px;
  background: ${({ hex }) => hex};
  border-radius: 100%;
  margin-right: 10px;
`

export const SelectIconContainer = styled.div`
  display: flex;
  align-items: center;
`
